export default __webpack_public_path__ + "static/sfx-22446e6f18615d8b2a2f5877bfdefe7a.m4a";